import React, { useState } from "react";
import TextInput from "../shared/TextInput";
import Dropdown from "./Dropdown";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";

const StepTwo = ({ control, handleChange, contact, setContact }) => {
  // ----------- hooks ------------
  const { t } = useTranslation();

  return (
    <div className="text-black">
      <h3 className="text-xl text-purple">{t("Second Step")}</h3>
      <form action="">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold pb-5">
            {t("Personal Information")}
          </h1>
        </div>
        <Controller
          name="first_name"
          control={control}
          defaultValue={""}
          rules={{
            required: "First Name is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("First Name")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="middle_name"
          control={control}
          defaultValue={""}
          rules={{
            required: "Middle Name is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Second Name")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="last_name"
          control={control}
          defaultValue={""}
          rules={{
            required: 'Last Name is required',
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Last Name")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="birth_date"
          control={control}
          defaultValue={""}
          rules={{
            required: "Birthday is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Birthday")}</p>
              </label>
              <input
                type="date"
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
          
        />
            <Controller
          name="phone"
          control={control}
          defaultValue={""}
          rules={{
            required: 'Phone Code is required',
            pattern: {
              value: /^\d+$/,
              message: 'Only numeric values are allowed',
            },
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Phone")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
                onInput={(e) => {
                  // Allow only numeric input
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
              />
            </div>
          )}
        />
        <Controller
          name="email"
          control={control}
          defaultValue={""}
          rules={{
            required: 'Email is required',
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: 'Invalid email address',
            },
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Email")}</p>
              </label>
              <input
                type="email"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="city"
          control={control}
          defaultValue={""}
          rules={{
            required: "City is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("City")}</p>
              </label>
              <input
                type="text"
                placeholder={t("Write") + "..."}
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
        />
        <Controller
          name="country"
          control={control}
          defaultValue={""}
          rules={{
            required: "Country is required",
          }}
          render={({ field }) => (
            <div className="mb-4">
              <label htmlFor="name">
                <p className="text-md font-medium">{t("Country")}</p>
              </label>
              <input
                type="text"
                className="border border-gray rounded-md mt-2 text-sm w-48 px-3 py-2"
                {...field}
              />
            </div>
          )}
          
        />
        
      </form>
    </div>
  );
};

export default StepTwo;
